var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content-body"},[_c('go-back-button'),_c('h1',{staticClass:"page-title mb-4"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2),_c('footer',{staticClass:"sticky-button-container"},[_c('div',{staticClass:"sticky-button-wrapper"},[_vm._t("footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }